import { render, staticRenderFns } from "./WarehouseSecondChildren.vue?vue&type=template&id=79baf298"
import script from "./WarehouseSecondChildren.vue?vue&type=script&lang=js"
export * from "./WarehouseSecondChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports